import { cn } from '@/lib/utils';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import {
  progressIndicatorsVariants,
  progressIndicatorVariants,
  progressRootVariants,
} from './progress-variants';

export interface ProgressProps
  extends
    React.ComponentProps<typeof ProgressPrimitive.Root>,
    VariantProps<typeof progressRootVariants> {
  indicators?: number[];
}

function Progress({ className, value, indicators = [], variant, ...props }: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(progressRootVariants({ variant, className }))}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(progressIndicatorVariants({ variant }))}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
      {indicators?.length > 0
        ? indicators.map((indicator, index) => (
            <div
              key={index}
              className={cn(progressIndicatorsVariants({ variant }))}
              style={{ left: `${indicator}%` }}
            />
          ))
        : null}
    </ProgressPrimitive.Root>
  );
}

export { Progress };
